import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { projectsData } from "../../static/data";

const FeaturedProjects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    // Filter specifically for these 3 projects
    const selectedProjects = projectsData.filter((project) => {
      const titles = ["Monetra", "Learneazy", "Buyno", "Gher.com"];
      return titles.some((t) => project.title.includes(t));
    });
    // Ensure the order is exactly as requested: Monetra, Learneazy, Buyno
    const orderedProjects = [
      selectedProjects.find((p) => p.title.includes("Monetra")),
      selectedProjects.find((p) => p.title.includes("Learneazy")),
      selectedProjects.find((p) => p.title.includes("Buyno")),
      selectedProjects.find((p) => p.title.includes("Gher.com")),
    ].filter(Boolean);

    setProjects(orderedProjects);
  }, []);

  return (
    <section className="featured section" id="featured__projects">
      <div className="container">
        <div className="featured__header">
          <h2 className="featured__title">
            Explore my latest <br />
            <span className="featured__title-highlight">Full-Stack</span>{" "}
            projects
          </h2>
          <p className="featured__subtitle">
            From technical architecture to high-performance implementation.{" "}
            <br />
            Here’s a deep dive into how I solve complex problems with code.
          </p>
        </div>

        <div className="featured__container grid">
          {projects.map((project) => (
            <div className="featured__card" key={project.id}>
              {/* Left Side: Image Only */}
              <div className="featured__visuals">
                <div className="featured__img-wrapper">
                  <img src={project.mainimage} alt={project.title} />
                </div>
              </div>

              {/* Right Side: Title, Description, Button */}
              <div className="featured__info">
                <div>
                  <h3 className="featured__project-title">{project.title}</h3>
                  <p className="featured__project-desc">
                    {project.description}
                  </p>
                </div>

                <div className="featured__actions">
                  <Link
                    to={`/projects/${encodeURIComponent(project.title)}`}
                    className="featured__cta"
                  >
                    View Full Case Study
                    <i className="uil uil-arrow-up-right featured__cta-icon"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
